/**
 * Responsive layout shift
 * Use: import { recipeResponsiveLayout } from "./components/recipes";
 */
export function recipeResponsiveLayout() {
	const	Browser			= $(window);
	let		InitialWidth	= Browser.width(),
			moveResponsive	= true,
			moveDesktop		= false;

	// Adjust layout directly if visiting from mobile device
	if( InitialWidth <= 768 ) {
		recipeImageResponsive( true );
		moveResponsive	= false;
		moveDesktop		= true;
	}

	//Resize listener to adjust layout
	Browser.on('resize', function() {
		let win				= $(this),
			BrowserWidth 	= win.width();

		if( BrowserWidth <= 768 ) {
			if( moveResponsive ) {
				recipeImageResponsive( true );
				moveResponsive	= false;
				moveDesktop		= true;
			}

		}else{
			if( moveDesktop ) {
				recipeImageResponsive( false );
				moveResponsive	= true;
				moveDesktop		= false;
			}
		}
	});
}

// Function to adjust layout. Params: bool
// If true moves to column 2 - Responsive layout
// If false moves back to column 1 - Desktop
function recipeImageResponsive( bool ){
	const	columnOne = $('.recipe-single-image-used'),
			columnTwo = $('.recipe-single-content'),
			featuredImage = $('.recipe-image'),
			prodeuctsUsed = $('.recipe-used');

	// Responsive layout adjustment
	if( bool === true ) {
		columnTwo.prepend( featuredImage );
		columnTwo.append( prodeuctsUsed );

	// Desktop layout adjustment
	} else if( bool === false ) {
		columnOne.prepend( featuredImage );
		columnOne.append( prodeuctsUsed );
	}
}